import API from '../../api/api';
import utils from '../../../modules/utils';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage(queryParams) {
  return !!(utils.fn.getURIParam(queryParams, 'orderKey'));
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  return API.doAPIRequest('/v2/return-from-hosted/worldpay',
    queryParams.substring(1),
    'application/x-www-form-urlencoded; charset=UTF-8');
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
